import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from './components/ErrorBoundary'
import App from './App.tsx'
import './index.css'
import './lib/i18n'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: (failureCount, error: any) => {
        // Don't retry on 401 (unauthorized) or 404 (not found) in development
        if (import.meta.env.DEV && (error?.response?.status === 401 || error?.response?.status === 404)) {
          console.warn('🚫 Not retrying failed request in development mode:', error?.config?.url);
          return false;
        }
        // Retry other errors up to 1 time
        return failureCount < 1;
      },
      // Don't throw errors globally, let components handle them
      throwOnError: false,
    },
    mutations: {
      // Don't throw errors globally for mutations either
      throwOnError: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)